import './other';
import Vue from "vue";
import { App as InertiaApp, plugin as InertiaPlugin } from "@inertiajs/inertia-vue";
import { Link } from "@inertiajs/inertia-vue";
import { InertiaProgress } from "@inertiajs/progress";

import Vuetify from 'vuetify'
Vue.use(Vuetify);


Vue.config.productionTip = false;
import PortalVue from 'portal-vue';
Vue.use(PortalVue);


Vue.use(InertiaPlugin);
Vue.component("Link", Link);
Vue.mixin({ methods: { route: window.route } });
const app = document.getElementById("app");


new Vue({
    vuetify: new Vuetify({
        theme: {
            themes: {
                light: {
                    success: '#4caf54',
                    primary: '#246fb3',
                },
                dark: {
                    success: '#4caf54',
                    primary: '#246fb3',
                },
            },
        },

    }),
    render: h =>
        h(InertiaApp, {
            props: {
                title: title => `${title} - Admin Portal`,
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: name => require(`./Pages/${name}`).default
            }
        }),
}).$mount(app);

InertiaProgress.init({
    color: "#246fb3",
    showSpinner:true
});
